import { cartFetch, exportFetch } from '../fetch';
import type { IAppendCartOption, ICart, ICartProduct } from './types';

/** 获取购物车详情 */
export const fetchCart = () => cartFetch.post<void, ICart>('/cart/cartDetail');

/** 合并缓存购物车信息 */
export const mergeCart = (
  data: (Pick<ICartProduct, 'id' | 'skuCode' | 'checked' | 'qty'> & IAppendCartOption)[]
) => cartFetch.post<void, ICart>('/cart/mergeCacheCart', data);

/** 清空购物车 */
export const clearCart = () => cartFetch.post<void, void>('/cart/deleteAllCartItem');

/**批量添加购物车 */
export const batchProductToCart = data => cartFetch.post<void, void>('/cart/addCartItems', data);

/** 添加商品到购物车 */
export const addProductToCart = (
  data: Pick<ICartProduct, 'skuCode' | 'checked' | 'qty' | 'newItem'> & IAppendCartOption
) => cartFetch.post<void, void>('/cart/addCartItem', data);

/** 删除购物车商品 */
export const removeProductInCart = (data: ICartProduct['id'][]) =>
  cartFetch.post<void, void>('/cart/deleteCartItem', data);

/** 修改购物车商品数量 */
export const updateProductQtyInCart = (data: Pick<ICartProduct, 'id' | 'qty'>) =>
  cartFetch.post<void, void>('/cart/editCartItemQty', data);

/** 选中购物车商品 */
export const updateSelectedProductInCart = (data: Pick<ICartProduct, 'id' | 'checked'>) =>
  cartFetch.post<void, void>('/cart/selectCartItem', data);

/** 批量选中购物车商品 */
export const updateSelectedProductsInCart = (data: { id: string[]; checked: boolean }) =>
  cartFetch.post<void, void>('/cart/selectCartItems', data);

/** 查询购物车是否存在加购的商品 */
export const fetchCheckExist = (data: Pick<ICartProduct, 'skuCode'>) =>
  cartFetch.post<void, boolean>('/cart/checkExist', null, { params: data });

/** 商品是否已存在购物车中【支持批量查询】 */
export const checkHasProductInCart = (data: string | string[]) =>
  cartFetch.post<void, boolean>('/cart/checkExistBatch', typeof data === 'string' ? [data] : data);

/** 获取通过本地缓存数据解析购物车全量数据【价格等】 */
export const fetchParseCartByLocalCache = (
  data: (Pick<ICartProduct, 'id' | 'skuCode' | 'checked' | 'qty'> & { createTime: string })[]
) => cartFetch.post<void, ICart>('/cart/cacheCartDetail', data);

/** 获取服务器当前时间 */
export const fetchCurrentDatetime = () => Promise.resolve({ currentTime: Date.now() + '' });
// cartFetch.post<void, { currentTime: string }>('/cart/getCurrentTime');

/** 导出报价单 */
export const exportQuotation = (data) => exportFetch.post<void, void>('/cart/exportCheckedCartItem', data);
/**快速下单模板 */
export const quickAddDownload = () =>
  exportFetch.post<void, void>('/cart/quickAddTemplateDownload');
/**SDI订单模板 */
export const quickTemplate = () => exportFetch.post<void, void>('/cart/sdi/quick/import/template');
/**手动导入 */
export const SDIXlsx = (data: any) => cartFetch.post<void, void>('/cart/sdi/quick/import', data);
/**上传文件 */
export const quickAddXlsx = (data: any) => cartFetch.post<void, void>('/cart/quickAddXlsx', data);
/**手动导入 */
export const addQuickAddXlsx = (data: any) => cartFetch.post<void, void>('/cart/quickAdd', data);

/**查询当前用户的快速下单模板 */
export const queryUserTemplate = (data: any) =>
  cartFetch.post<void, void>('/cartQuickAddTemplate/queryByUser', data);

/**保存或更新当前用户的快速下单模板 */
export const updateUserTemplate = (data: any) =>
  cartFetch.post<void, void>('/cartQuickAddTemplate/saveOrUpdate', data);

/**修改订货号 */
export const updateSkuCode = (data: any) => 
  cartFetch.post<void, void>('/cart/updateSkuCode', data);
